import { render, staticRenderFns } from "./pdf-pages-viewer.vue?vue&type=template&id=0e57e9c1&scoped=true"
import script from "./pdf-pages-viewer.ts?vue&type=script&lang=ts&external"
export * from "./pdf-pages-viewer.ts?vue&type=script&lang=ts&external"
import style0 from "./pdf-pages-viewer.less?vue&type=style&index=0&id=0e57e9c1&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e57e9c1",
  null
  
)

export default component.exports